import { useCallback, useRef } from 'react'

import { useFocusEffect } from '@react-navigation/native'

const useFetchRef = (action: VoidFunction) => {
  const fetchRef = useRef(true)

  useFocusEffect(
    useCallback(() => {
      if (fetchRef.current) {
        fetchRef.current = false
        return
      }

      action()
    }, [action])
  )
}

export { useFetchRef }
